export const LUXURY_PLUS_PATHS = {
  LANDING_PAGE: 'LuxuryPlus',
  ACCOUNT_MANAGEMENT_PAGE: 'account/manage-luxuryPlus',
} as const

export const LUXURY_PLUS = {
  PROGRAM_NAME: 'LuxPlus+',
} as const
